import Cookies from "js-cookie";
import { noticeError } from "../newrelic/requests";

const MONETATE_ID_COOKIE_NAME = "mt.v";
const MONETATE_API_URL =
  "https://engine.monetate.net/api/engine/v1/decide/JohnLewis";

export const postMonetateImpression = async (
  impressionId: string,
  monetateEnvironment: string,
) => {
  const monetateId = Cookies.get(MONETATE_ID_COOKIE_NAME);

  if (impressionId && monetateEnvironment) {
    const impressionRecord = {
      channel: monetateEnvironment,
      monetateId: monetateId,
      events: [
        {
          eventType: "monetate:record:Impressions",
          impressionIds: [impressionId],
        },
      ],
    };

    fetch(MONETATE_API_URL || "", {
      method: "POST",
      body: JSON.stringify(impressionRecord),
    }).catch((e: Error) => {
      noticeError(`Monetate API error: error ${e.message}`);
    });
  }
};
